var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64062 1.59375H4.48438C4.57031 1.59375 4.64062 1.52344 4.64062 1.4375V1.59375H10.5781V1.4375C10.5781 1.52344 10.6484 1.59375 10.7344 1.59375H10.5781V3H11.9844V1.4375C11.9844 0.748047 11.4238 0.1875 10.7344 0.1875H4.48438C3.79492 0.1875 3.23438 0.748047 3.23438 1.4375V3H4.64062V1.59375ZM14.4844 3H0.734375C0.388672 3 0.109375 3.2793 0.109375 3.625V4.25C0.109375 4.33594 0.179688 4.40625 0.265625 4.40625H1.44531L1.92773 14.6211C1.95898 15.2871 2.50977 15.8125 3.17578 15.8125H12.043C12.7109 15.8125 13.2598 15.2891 13.291 14.6211L13.7734 4.40625H14.9531C15.0391 4.40625 15.1094 4.33594 15.1094 4.25V3.625C15.1094 3.2793 14.8301 3 14.4844 3ZM11.8926 14.4062H3.32617L2.85352 4.40625H12.3652L11.8926 14.4062Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.dda70852018ee8778bba36483950a921.svg";
export { ForwardRef as ReactComponent };